import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { listAction } from "../../../network/store/action/CategoryResponseAction";
import { listAction as subCategoryListAction } from "../../../network/store/action/SubCategoryResponseAction";
import noImage from "../../../assets/no_image.jpg";
import { getImagePath } from "../../../utils/util";
import { consoleLog } from "../../../utils/log-utils";
import UniqueStoreProductAdding from "./uniqueStore-product-adding";
import { useLocation, useNavigate } from "react-router-dom";
import { API_CONFIG, API_HEADERS } from "../../../network/config/ApiConfig";
import { updateMessage } from "../../../redux/slice/toastSlice";
import { axiosApi } from "../../../network/service/config/AaxiosUtil";
import axios from "axios";

function StoreCategoryAdding() {
  const location=useLocation();
  const storeId=location.state!==null?location.state.storeId:"";
  const [categoryList, setCategoryList] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [categoryId,setCategoryId]=useState(null);
  const [subCategoryStatus,setSubCategoryStatus]=useState(false);
  const [subCategoryId,setSubCategoryId]=useState(null);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const dispatch = useDispatch();
  const navigate=useNavigate();
  const [isClick, setClickValue] = useState(false);
  const [isProductClick, setProductClickValue] = useState(false);
  const [isSubCategoryUpdate,setIsSubCategoryUpdate]=useState(false);
  const [item,setItem]=useState(null);

  

  useEffect(() => {
    fetchCategoryList();
  }, [])
useEffect(()=>{
  getSubCategories(categoryId);
},[isSubCategoryUpdate])
  useEffect(()=>{
    isProductClick && navigate("/uniqueStoreProduct",{state:{
      categoryId:categoryId,
      subCategoryId:subCategoryId,
      storeId:storeId
    }})

  },[isProductClick])

  const fetchCategoryList = async () => {
    await dispatch(
      listAction(
        {
          secId: "",
        },
        dispatch
      )
    ).then((reponse) => {


      if (reponse.result) {
        setCategoryList(reponse.result);
      } else {
        setCategoryList([]);
      }
    });
  };

  const getSubCategories = async (catId) => {
    setSubCategoryList([]);
    // await dispatch(
    //   subCategoryListAction(
    //     {
    //       secId: catId,
    //     },
    //     dispatch
    //   )
    // ).then((response) => {
    //   if (response.result) {
    //     setSubCategoryList(response.result);
    //   }
    // });
    let data=await axios.get(`http://localhost:8080/SubCategory/storeCategories?categoryId=${catId}&storeId=${storeId}`,{
      headers:API_HEADERS
    }
    )
    consoleLog("store subcategories",data.data.result)
    setSubCategoryList(data.data.result)
  };

  // StoreCategory/update
//   @JsonKey(name: "storeId")
// @JsonKey(name: "categoryId")
// @JsonKey(name: "id")
// @JsonKey(name: "status") // YES / NO

 const onStatusChange = async (product) => {
  consoleLog("onchange product",product)
  consoleLog("storeCategoryId",product.storeCategoryId)
    let changingStatus = "YES";
    if (product.storeCategoryStatus == "NO") {
      changingStatus = "YES";
    } else {
      changingStatus = "NO";
    }
     let requestBody=null;
     if(product.storeCategoryId!=="NO"){
      requestBody = {
        storeId:storeId,
        status: changingStatus,
        categoryId:product.id,
        id:product.storeCategoryId
      };
     }
     else{
      requestBody = {
        storeId:storeId,
        status: changingStatus,
        categoryId:product.id,
      };
     }
     

    await axiosApi
      .post(API_CONFIG.API_HOST +"StoreCategory/update" , requestBody, {
        API_HEADERS,
      })
      .then((response) => {
        consoleLog("STORE category UPODATE", response);
        if (response.status === 200 && response.data.status === true) {
          // setItem(product, (product.status = changingStatus));
          setSubCategoryStatus(changingStatus);
          setIsSubCategoryUpdate(isSubCategoryUpdate=>!isSubCategoryUpdate)
        } else {
          dispatch(
            updateMessage({
              display: true,
              message: "Error While updating info",
            })
          );
        }
      });
  };

  return (
    <>
      <div className="row d-flex flexx-row ">
        <div className="col-md-12 col-lg-6 card-1 h-scroll mt-5">
          <div className="p-5">
            <table className="table table-hover align-middle">
              <thead className="thead-dark">
                <tr id="Row1">
                  <th scope="col-1">Category Image</th>
                  <th Scope="col-1">Name</th>
                  {/* <th scope="col-1">Status</th> */}
                </tr>
              </thead>

              <tbody>
                {
                  categoryList && categoryList.length > 0 && categoryList.map((obj, sno) => {
                    return (
                      <tr id={obj.id} onClick={() => {
                        setClickValue(true);
                        getSubCategories(obj.id);
                        setCategoryName(obj.name);
                        setCategoryId(obj.id);
                      }}>
                        <td>
                        {
                          obj.image_path !== "" ? (
                            <img
                            src={getImagePath(obj.image_path)}
                            alt={obj.name}
                            className="img-thumbnail"
                            width="50px"
                            height="50px"
                          />
                          ) : (
                            <img
                              src={noImage}
                              // alt={obj.name}
                              className="img-thumbnail"
                              width="50px"
                              height="50px"
                            />
                          )
                
                        }

                         
                        </td>
                        <td>{obj.name}</td>
                        {/* <td>
                          <div className="form-check form-switch d-flex flex-row justify-content-center">

                            <input type="checkbox"
                              className="form-check-input"

                              checked={obj.status === "YES" ? true : false}
                              role="switch"
                            />
                          </div>

                        </td> */}
                      </tr>
                    )
                  })
                }
              </tbody>

            </table>
          </div>

        </div>

        {
          isClick && <>
            <div className="col-md-12 col-lg-6 card-1 h-scroll mt-5">

              <div className="p-5">
                <h6 className="text-center-new" style={{ textDecoration: "underline" }}>{categoryName}</h6>
                <table className="table table-hover align-middle">
                  <thead className="thead-dark">
                    <tr id="Row1">
                      <th scope="col-1">Sub Category Image</th>
                      <th Scope="col-1">Name</th>
                      <th scope="col-1">Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {
                      subCategoryList && subCategoryList.length > 0 && subCategoryList.map((obj, sno) => {
                        return (
                          <tr id={obj.id} onClick={()=>{
                          setSubCategoryStatus(obj.storeCategoryStatus)
                           setSubCategoryId(obj.id)
                           
                          }}>
                            <td>
                              <img
                                src={getImagePath(obj.image_path)}
                                // alt={obj.name}
                                className="img-thumbnail"
                                width="50px"
                                height="50px"
                              />
                            </td>
                            <td onClick={()=>obj.storeCategoryStatus==="YES"&&setProductClickValue(true)}>{obj.name}</td>
                            <td>
                              <div className="form-check form-switch d-flex flex-row justify-content-center">

                                <input type="checkbox"
                                  className="form-check-input"
                                  onChange={()=>{onStatusChange(obj);
                                    
                                  }}
                                  checked={obj.storeCategoryStatus === "YES" ? true : false}
                                  role="switch"
                                />
                              </div>

                            </td>
                          </tr>
                        )
                      })
                    }
                  </tbody>

                </table>
              </div>

            </div>
          </>
        }
       

        
        

      </div>
    </>
  )

}
export default StoreCategoryAdding